import { Component, inject, model, ChangeDetectionStrategy, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

export interface DialogData {
  title: string;
  textChunks: { text: string;  isStrong?: boolean }[];
  cancelButtonText: string;
  confirmButtonText: string;
}

@Component({
  selector: 'app-generic-dialog',
  standalone: true,
  imports: [
      MatDialogModule,
      MatFormFieldModule,
      MatInputModule,
      FormsModule,
      MatButtonModule,
      MatDialogTitle,
      MatDialogContent,
      MatDialogActions
  ],
  templateUrl: './generic-dialog.component.html',
  styleUrl: './generic-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenericDialog {
  readonly dialogRef = inject(MatDialogRef<GenericDialog>);
  readonly data = inject<DialogData>(MAT_DIALOG_DATA);
  
  readonly title = this.data.title || 'Warnung';
  readonly textChunks = this.data.textChunks || [
    { text: 'Sind Sie sicher, dass Sie dieses Element löschen möchten?' }
  ];
  readonly cancelButtonText = this.data.cancelButtonText || 'Abbrechen';
  readonly confirmButtonText = this.data.confirmButtonText || 'Ja, löschen';


  onCancel(): void {
    this.dialogRef.close(false);
  }

  onDelete(): void {
    this.dialogRef.close(true); 
  }
}
